(function($) {
    var documentLoad = function() {
        $('.img-slider-text-slider').each(function() {
            var hm = this;
            var options = {
                nextArrow: $(hm).parent().find('.next-arrow'),
                prevArrow: $(hm).parent().find('.prev-arrow'),
                dots: true,
                autoplay: true,
                autoplaySpeed: $(hm).data('interval'),
            };
            $(hm).on('init' , function() {
                $(hm).removeClass('loading');
            });
            $(hm).slick(options);
        });
        $('.img-slider-content-width-slider').each(function () {
            var hm = this;
            var options = {
                nextArrow: $(hm).parent().find('.next-arrow'),
                prevArrow: $(hm).parent().find('.prev-arrow'),
                autoplay: true,
                autoplaySpeed: $(hm).data('interval'),
                asNavFor: '.img-slider-content-width-nav',
            };
            $(hm).on('init' , function() {
                $(hm).removeClass('loading');
            });
            $(hm).slick(options);
        });
        $('.img-slider-content-width-nav').each(function () {
            var hm = this;
            var options = {
                nextArrow: '',
                prevArrow: '',
                autoplay: false,
                autoplaySpeed: $(hm).data('interval'),
                asNavFor: '.img-slider-content-width-slider',
                slidesToShow: 12,
                focusOnSelect: true,
                responsive: [
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 9,
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 7,
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 5,
                      }
                    }
                ]
            };
            $(hm).on('init' , function() {
                $(hm).removeClass('loading');
            });
            $(hm).slick(options);
        });
        $('.img-slider-mini-slider').each(function () {
            var hm = this;
            var options = {
                nextArrow: $(hm).parent().find('.next-arrow'),
                prevArrow: $(hm).parent().find('.prev-arrow'),
                autoplay: true,
                autoplaySpeed: $(hm).data('interval'),
            };
            $(hm).on('init' , function() {
                $(hm).removeClass('loading');
            });
            $(hm).slick(options);
        });
        $('.img-slider-thumbnail').each(function() {
            var imageThumbnailGallery = this;
            $(imageThumbnailGallery).find('.thumbnail-image-wrapper').matchHeight();
        });
        $(".pop").each(function () {
            var imageElement = this;
            $(imageElement).on("click", function() {
                // Wipe previous values
                $('#imagepreview').attr('src', '');
                $('#image-description').empty();
                $('#image-download-link').attr('href', '');

                // Assign new values
                $('#imagepreview').attr('src', $(imageElement).data('orig')); // here asign the image to the modal when the user click the enlarge link
                if($(imageElement).siblings('.thumbnail-description').length == 1) {
                   $('#image-description').html($(imageElement).siblings('.thumbnail-description').html());
                }
                $('#image-download-link').attr('href', $(imageElement).data('orig'));
                $('#imagemodal').modal('show'); // imagemodal is the id attribute assigned to the bootstrap modal, then i use the show function
            });
        });
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/image-slider.js